import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { ACCOUNT_MANAGER } from '../../fields';
import { ACCOUNT_MANAGER_VIDEO_REPORT_ID } from './accountManagerVideoReportId';

const reportFooterColumnDefinition = [ACCOUNT_MANAGER].map(createFooterMapper(ACCOUNT_MANAGER_VIDEO_REPORT_ID));

export default reportFooterColumnDefinition;
